import {type Dispatch, type Reducer, useReducer} from 'react'

import {ClipboardActionTypes} from './constants'
import {emptyClipboard} from './empty-clipboard'
import type {ClipboardAction, ClipboardState} from './types'

const reducer: Reducer<ClipboardState, ClipboardAction> = (state, action) => {
  switch (action.type) {
    case ClipboardActionTypes.CLEAR_CLIPBOARD:
      return emptyClipboard
    case ClipboardActionTypes.UPDATE_CLIPBOARD: {
      const copiedCells = action.state.reduce((acc, row) => {
        if (row.length === 1) {
          const cell = row[0]
          if (cell && cell.itemId && cell.columnId) {
            acc.set(cell.itemId, {columnId: cell.columnId.toString()})
          }
        }
        return acc
      }, new Map())

      return {type: 'populated', value: action.state, hideCopyOutline: false, copiedCells}
    }
    case ClipboardActionTypes.PASTE_CLIPBOARD_MULTIROW:
      return state.type === 'populated' ? {...state, hideCopyOutline: true} : state
    default:
      return state
  }
}

export const useClipboardReducer = (initialState: ClipboardState): [ClipboardState, Dispatch<ClipboardAction>] => {
  return useReducer(reducer, initialState)
}
